const iconAccount = `
  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <path d="M0 0h30v30H0z"/>
      <g class="icon-color" fill-rule="nonzero" transform="translate(4 3)" fill="#008AB7">
        <path d="M19.47 9.895V21.27h-1.695v-7.814c0-.933-.717-1.7-1.625-1.775l-.145-.006a1.78 1.78 0 0 0-1.779 1.781v7.814h-1.547v-7.814c0-.933-.716-1.7-1.625-1.775l-.145-.006a1.78 1.78 0 0 0-1.778 1.781v7.814H7.576v-7.814c0-.933-.717-1.7-1.625-1.775l-.145-.006a1.78 1.78 0 0 0-1.779 1.781v7.814H2.266V9.895H19.47z"/>
        <rect x="1.153" y="21.046" width="3.988" height="1.115" rx=".558"/>
        <rect x="6.269" y="21.046" width="3.983" height="1.115" rx=".558"/>
        <rect x="11.609" y="21.046" width="3.972" height="1.115" rx=".558"/>
        <rect x="16.733" y="21.046" width="3.943" height="1.115" rx=".558"/>
        <path d="M.48 21.936h21.042V24H.48zM0 8.64h22L10.62 0z"/>
      </g>
    </g>
  </svg>
`

export default iconAccount
